export default __webpack_public_path__ + "static/media/fi5.5ca628ce.png";